import { render, staticRenderFns } from "./WallpaperCreate.vue?vue&type=template&id=d1345fc4&scoped=true&"
import script from "./WallpaperCreate.vue?vue&type=script&lang=js&"
export * from "./WallpaperCreate.vue?vue&type=script&lang=js&"
import style0 from "./WallpaperCreate.vue?vue&type=style&index=0&id=d1345fc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1345fc4",
  null
  
)

export default component.exports